<div class="auth-wrapper auth-v1 px-2">
  <div class="auth-inner py-2">
    <!-- Forgot Password v1 -->
    <div class="card mb-0">
      <div class="card-body">
        <a
          class="brand-logo"
          href="/">
          <img
            [src]="logoService.logoPath"
            alt="brand-logo"
            height="50" />
        </a>

        <h4
          [translate]="'AUTH.PASSWORD.FORGOT_HEADER'"
          class="card-title mb-1"></h4>
        <p
          [translate]="'AUTH.PASSWORD.RESET'"
          class="card-text mb-2"></p>

        <form
          (ngSubmit)="onSubmit()"
          [formGroup]="forgotPasswordForm"
          class="auth-forgot-password-form mt-2">
          <div class="mb-3">
            <label
              [translate]="'AUTH.EMAIL'"
              class="form-label"
              for="forgot-password-email"></label>
            <div
              [ngClass]="{ 'is-invalid': submitted && f['email'].errors }"
              class="input-group input-group-merge">
              <div class="input-group-prepend">
                <span class="input-group-text"><span [data-feather]="'user'"></span></span>
              </div>
              <input
                [ngClass]="{ 'is-invalid': submitted && f['email'].errors }"
                aria-describedby="forgot-password-email"
                autofocus
                class="form-control"
                formControlName="email"
                id="forgot-password-email"
                placeholder="max@mustermann.at"
                tabindex="1"
                type="email" />
            </div>
            @if (submitted && f["email"].errors) {
              <div class="invalid-feedback">
                @if (f["email"].errors["required"]) {
                  <div [translate]="'AUTH.ERRORS.EMAIL_REQUIRED'"></div>
                }
                @if (f["email"].errors["email"]) {
                  <div [translate]="'AUTH.ERRORS.EMAIL'"></div>
                }
              </div>
            }
          </div>
          <button
            [translate]="'AUTH.PASSWORD.RESET_LINK'"
            class="btn btn-primary d-block w-100"
            rippleEffect
            tabindex="2"></button>
        </form>

        <p class="text-center mt-2">
          <a routerLink="/login">
            <i
              class="mb-25"
              data-feather="chevron-left"></i>
            {{ "AUTH.BACK_TO_LOGIN" | translate }}
          </a>
        </p>
      </div>
    </div>
    <!-- /Forgot Password v1 -->
  </div>
</div>
